/**
 * Browser fallback for opening payment / external links outside the host WebView.
 */
export function openExternalUrl(url: string): void {
  if (typeof window === 'undefined' || !url) {
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}
